import React from 'react'
import { Outlet } from 'react-router-dom'
import MenuView from '@/layout/MenuView'
import Basic from './Basic'
import Security from './Security'
import Verification from './Verification'
import Ticket from './Ticket'
import Share from './Share'
import Notifications from './Notifications'

const Account = () => {
  return (
    <MenuView>
      <Outlet />
    </MenuView>
  )
}

Account.Basic = Basic
Account.Security = Security
Account.Verification = Verification
Account.Ticket = Ticket
Account.Share = Share
Account.Notifications = Notifications

export default Account
